import { AlertCircle, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PageErrorProps {
  onRetry?: () => void;
}

export function PageError({ onRetry }: PageErrorProps) {
  return (
    <div className="flex h-[60vh] w-full flex-col items-center justify-center rounded-xl border border-dashed bg-muted/30 p-8 text-center animate-in fade-in duration-300">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
        <AlertCircle className="h-6 w-6 text-destructive" />
      </div>

      <h2 className="mt-4 text-lg font-semibold tracking-tight">
        Unable to load information
      </h2>

      <p className="mt-2 text-sm text-muted-foreground max-w-[300px]">
        Something went wrong on our end. Please try refreshing the data or check
        back in a moment.
      </p>

      <Button
        variant="outline"
        size="sm"
        className="mt-6 border-destructive/20 hover:bg-destructive/5"
        onClick={() => (onRetry ? onRetry() : window.location.reload())}
      >
        <RefreshCcw className="mr-2 h-4 w-4" />
        Try Again
      </Button>
    </div>
  );
}
